module.exports = __webpack_public_path__ + "img/location-pin-solid.a1ce7c8e.svg";